function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Icon_awesome-star",
  "data-name": "Icon awesome-star",
  d: "M5.9.332,4.684,2.807l-2.731.4a.6.6,0,0,0-.331,1.021L3.6,6.151,3.131,8.87A.6.6,0,0,0,4,9.5L6.441,8.216,8.884,9.5a.6.6,0,0,0,.867-.63l-.467-2.72L11.26,4.226A.6.6,0,0,0,10.929,3.2L8.2,2.807,6.978.332A.6.6,0,0,0,5.9.332Z",
  transform: "translate(-1.441 0.001)",
  fill: "#e8e9ee"
});

var SvgStarGray = function SvgStarGray(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 9.571,
    viewBox: "0 0 10 9.571",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStarGray, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/star_gray.bdc10142.svg";
export { ForwardRef as ReactComponent };